import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { isFunction, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import { usePicklistOptions } from "hooks";
import Dropdown from "components/Dropdown";


const TeamPicker = ({
	onChange,
	value: incomingValue,
	...rest
}) => {
	const { options, isFetching: isLoading, hasError } = usePicklistOptions("adhocteams");
	const teamOptions = useMemo(() => {
		return options.map(team => ({
			key: team.id,
			value: team.id,
			text: team.name,
			team
		}));
	}, [ options ]);

	const handleChange = (event, { value: teamId }) => {
		const selectedTeam = isNonEmptyString(teamId)
			? teamOptions.find(({ key: optionId }) => optionId === teamId)
			: undefined;

		if (isFunction(onChange)) {
			onChange({ value: teamId, team: selectedTeam?.team });
		}
	};

	return !isLoading
		? (
			<div data-component="TeamPicker">
				<Dropdown options={teamOptions}
						  onChange={handleChange}
						  value={incomingValue}
						  {...rest}
				/>
			</div>
		)
		: "";
};

TeamPicker.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string,
		PropTypes.number
	])
};

export default TeamPicker;
